// ============================================================
// 本番用: navigator.geolocation.watchPosition
// ============================================================

import type { Fix } from '../types'
import type { LocationProvider } from './location'

export class GeolocationProvider implements LocationProvider {
  private watchId: number | null = null
  private fix: Fix | null = null
  private handlers = new Set<(f: Fix) => void>()

  async start(): Promise<void> {
    if (!('geolocation' in navigator)) {
      throw new Error('navigator.geolocation is not available')
    }
    if (this.watchId !== null) return

    this.watchId = navigator.geolocation.watchPosition(
      (pos) => {
        const fix: Fix = {
          lat: pos.coords.latitude,
          lon: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
          speed: pos.coords.speed ?? null,
          heading: pos.coords.heading ?? null,
          timestamp: pos.timestamp,
        }
        this.fix = fix
        this.handlers.forEach((h) => h(fix))
      },
      (err) => {
        console.error('[GeolocationProvider] error', err)
      },
      { enableHighAccuracy: true, maximumAge: 5_000, timeout: 30_000 },
    )
  }

  stop(): void {
    if (this.watchId !== null) {
      navigator.geolocation.clearWatch(this.watchId)
      this.watchId = null
    }
  }

  current(): Fix | null {
    return this.fix
  }

  subscribe(handler: (f: Fix) => void): () => void {
    this.handlers.add(handler)
    if (this.fix) handler(this.fix)
    return () => this.handlers.delete(handler)
  }
}
